import RichText from '@/components/ui/rich-text'
import HubSpotForm from '@/components/ui/hubspot-form'
import HubiloForm from '@/components/ui/hubilo-form/hubilo-form'
import { cx } from '@/utils/strings'
import type { Entry } from 'contentful'
import { isTypeComponentHubiloForm, isTypeComponentHubSpotForm, type TypeSectionFormSkeleton } from '@/types/ctf'

type SectionFormEntry = Entry<TypeSectionFormSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>

export type Props = SectionFormEntry['fields']

export default function Form({ headline, body, form, anchorId, hideInitially }: Props): JSX.Element {
  return (
    <section className={cx('max-w-8xl px-5 lg:px-9 mx-auto', hideInitially && 'hidden')} id={anchorId}>
      <div className={cx('rounded-4xl bg-white dark:bg-secondary-800')}>
        <div className="mx-auto max-w-[800px] w-full py-12 px-5 ">
          <div className="px-5">
            {headline && <h3 className="text-center">{headline}</h3>}
            {body && (
              <div className="text-center max-w-3xl mx-auto mb-12">
                <RichText body={body} />
              </div>
            )}
          </div>

          {form && isTypeComponentHubSpotForm(form) && <HubSpotForm {...form.fields} />}
          {form && isTypeComponentHubiloForm(form) && <HubiloForm {...form.fields} id={form.sys.id} />}
        </div>
      </div>
    </section>
  )
}
